import { LuSparkles } from 'react-icons/lu';
import { FormField, FormFieldRow, TextInput } from '../../components';
import styles from '../styles.module.scss';

type OptionalFieldsSectionProps = {
    isDisableRepairFund: boolean;
    onRentChange: (value: string) => void;
};

export const OptionalFieldsSection = ({
    isDisableRepairFund,
    onRentChange,
}: OptionalFieldsSectionProps) => {
    return (
        <>
            <hr className={styles.optDivider} />

            <div className={styles.optHeader}>
                <span className={styles.optHeaderText}>もっと正確に知りたい場合（任意）</span>
            </div>

            <FormFieldRow>
                <FormField label="家賃・共益費・管理費（収入）" name="rent_price">
                    <TextInput
                        placeholder="例：80,000"
                        suffix="円"
                        type="number"
                        maxLength={6}
                        onChange={onRentChange}
                    />
                </FormField>
                <FormField
                    label="管理費・修繕積立金など（支出）"
                    name="repair_fund"
                    required={!isDisableRepairFund}
                >
                    <TextInput
                        placeholder={
                            isDisableRepairFund ? '収入を入力すると入力できます' : '例：10,000'
                        }
                        suffix="円"
                        type="number"
                        maxLength={7}
                        disabled={isDisableRepairFund}
                    />
                </FormField>
            </FormFieldRow>
        </>
    );
};
